import React from 'react';

const PlusIcon = () => (
  <svg width="25" height="24" viewBox="0 0 25 24" fill="none">
    <g id="Icons">
      <path id="Vector" fillRule="evenodd" clipRule="evenodd"
            d="M11.3687 17C11.3687 17.552 11.8157 18 12.3687 18C12.9207 18 13.3687 17.553 13.3687 17L13.3691 13.0006L17.3696 13.001C17.9216 13.001 18.3696 12.554 18.3696 12.001C18.3696 11.449 17.9226 11.001 17.3696 11.001L13.3693 11.0006L13.3697 7C13.3697 6.448 12.9227 6 12.3697 6C11.8177 6 11.3697 6.447 11.3697 7L11.3693 11.0004L7.36963 11C6.81763 11 6.36963 11.447 6.36963 12C6.36963 12.552 6.81663 13 7.36963 13L11.3691 13.0004L11.3687 17Z"
            fill="white"/>
    </g>
  </svg>

)

export default PlusIcon;